import React from 'react';

import { mergePurchase, fetchUserOverduePurchases } from 'api';
import { transformErrorResponse } from 'helpers/errors';
import FormError from '../FormError';
import ReactModal from 'react-modal';

export default class MergeOverduePurchases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      success: false,
      showModal: false,
    };
  }

  async mergePurchases() {
    const { userId, onComplete } = this.props;

    try {
      const overduePurchasesResponse = await fetchUserOverduePurchases(userId);
      const overduePurchases =
        overduePurchasesResponse &&
        overduePurchasesResponse.data &&
        overduePurchasesResponse.data.results;

      if (overduePurchases && overduePurchases.length > 1) {
        const { id } = overduePurchases[0];
        const { status } = await mergePurchase(id, {
          all_overdues: true,
        });

        if (status === 200 || status === 201) {
          this.setState({
            success: true,
            showModal: false,
          });

          onComplete();
        }
      } else {
        this.setState({
          error: {
            message: 'There is 1 or less overdue purchases. Cannot merge.',
          },
          isSent: false,
          showModal: false,
        });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        isSent: false,
        showModal: false,
      });
    }
  }

  toggleModal(state) {
    this.setState({ showModal: state });
  }

  render() {
    const { error, success } = this.state;
    const isDisabled = error || success;

    return (
      <React.Fragment>
        <button
          onClick={() => this.toggleModal(true)}
          className="btn btn-danger"
          disabled={isDisabled}
        >
          Merge overdue purchases
        </button>
        {error ? <FormError error={error} /> : null}
        {success ? (
          <div className="text-success">
            Overdue Purchases Successfully Merged.
          </div>
        ) : null}

        <ReactModal
          appElement={document.getElementById('root')}
          isOpen={this.state.showModal}
          contentLabel="Confirm Merge Overdue Purchases Modal"
          portalClassName="AdjustmentCreditPortal"
          overlayClassName="AdjustmentCreditModal__Overlay"
          className="AdjustmentCreditModal__Content"
        >
          <div className="modal-header">
            <span className="close">&times;</span>
            <h2>Confirm Merging Overdue Purchase</h2>
          </div>
          <div className="modal-body">
            <p>This action cannot be undone.</p>
          </div>
          <div className="modal-footer">
            <button
              className={'btn btn-primary'}
              onClick={() => this.mergePurchases()}
            >
              Merge
            </button>
            <button
              className={'btn'}
              onClick={() => {
                this.toggleModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
      </React.Fragment>
    );
  }
}
